<div *ngIf="publication.id">
		<div class="details">
			<div class="detailPresentationList">
                <div *ngIf="publication.title" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel"><span #ddKey [hisDdKey]="'fs.res.publication.Publication.title'">{{ddKey.ddLabeltext | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent"><span>{{publication.title}}</span></div>
				</div>
                <div *ngIf="publication.publicationType" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel"><span #ddKey [hisDdKey]="'fs.res.publication.Publication.publicationType'">{{ddKey.ddLabeltext | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent"><span>{{publication.publicationType.defaulttext}}</span></div>
				</div>
                <div *ngIf="publication.documentType" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel"><span #ddKey [hisDdKey]="'fs.res.publication.Publication.documentType'">{{ddKey.ddLabeltext | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent"><span>{{publication.documentType.defaulttext}}</span></div>
				</div>
                <div *ngIf="publication.creators" class="layoutBlock detailPresentationListItem">
                    <div class="columnDetailLabel detailPresentationListLabel"><span #ddKey [hisDdKey]="getTitleForCreatorLink()">{{ddKey.ddLabeltext | hisUi}}</span></div>
                    <div class="columnDetailContent detailPresentationListContent"><span>{{getCreatorsAsString()}}</span></div>
                </div>
				<ng-container *ngIf="!isEmpty(publication.globalIdentifiers)">
					<ng-container *ngFor="let identifier of publication.globalIdentifiers">
						<div *ngIf="isAnalogIdentifier(identifier)" class="layoutBlock detailPresentationListItem">
							<div class="columnDetailLabel detailPresentationListLabel"><span>{{identifier.globalIdentifierType.text}}</span></div>
							<div class="columnDetailContent detailPresentationListContent"><span>{{identifier.identifier}}</span></div>
						</div>
					</ng-container>
				</ng-container>
			 	<div *ngIf="publication.conference" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel"><span #ddKey [hisDdKey]="getDdKey('conference')">{{ddKey.ddLabeltext | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent"><span>{{publication.conference.defaulttext}}</span></div>
				</div>
				<div *ngIf="!isEmpty(publication.languages)" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel">
						<span *ngIf="1 < publication.languages.length; else singular">{{'common.i18n.LanguageValue' | hisUi}}</span>
						<ng-template #singular><span>{{'fs.res.common.language' | hisUi}}</span></ng-template>
					</div>
					<div class="columnDetailContent detailPresentationListContent">
						<ng-container *ngFor="let language of publication.languages; index as i, last as lastLanguage">
							{{language.text}}<span *ngIf="!lastLanguage">, </span>
						</ng-container>
					</div>
				</div>
				<div *ngIf="publication.series" class="layoutBlock detailPresentationListItem" [hisDdKey]="getDdKey('series')">
					<div class="columnDetailLabel detailPresentationListLabel"><span #ddKey [hisDdKey]="getDdKey('series')">{{ddKey.ddLabeltext | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent">
						<span>
							<span *ngIf="publication.series">{{publication.series}}</span>
							<span *ngIf="publication.series && publication.numberInSeries"> ; </span>
							<span *ngIf="publication.numberInSeries">{{publication.numberInSeries}}</span>
						</span>
					</div>
				</div>
				<div *ngIf="publication.edition" class="layoutBlock detailPresentationListItem" [hisDdKey]="getDdKey('edition')">
					<div class="columnDetailLabel detailPresentationListLabel"><span #ddKey [hisDdKey]="getDdKey('edition')">{{ddKey.ddLabeltext | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent"><span>{{publication.edition}}</span></div>
				</div>
				<div *ngIf="publication.publicationResource?.text" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel"><span #ddKey [hisDdKey]="getDdKey('publicationResource')">{{ddKey.ddLabeltext | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent"><span>{{publication.publicationResource.text}}</span></div>
				</div>
                <br>
                <res-collapsible-text-view
                    text="{{ publication | hisTranslate : 'textAbstract'}}"
                    header="fs.res.publication.abstract"
                    expandToolTip="fs.res.publication.view.showFullAbstract"
                    collapseToolTip="fs.res.publication.view.showShortAbstract">
                </res-collapsible-text-view>
				<div class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel"><span>{{'value.SubjectAreaValue' | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent wordBreak">
						<span *ngFor="let subjectArea of publication.subjectAreas">
							<a [routerLink]="['/pub/searchresult']"
								[queryParams]="{configFile: 'fs/res/searchPublicationHeadless.xml', pageTitle: 'fs.res.publication.search.data',
								tableTitle: 'fs.res.publication.search.found', 'Publication.subjectAreas.id[]': getSubjectAreaString(subjectArea), 'extended': true, showBackButton:true, isNotActiveSearch:true}"
								hisImage="tag_orange"
								class="singleLine transparent"
								title="{{ 'fs.res.common.subjectArea' | hisUi }}">{{subjectArea.text}}</a>
						</span>
					</div>
				</div>
                <div *ngIf="!isEmpty(publication.researchAreasKdsf)" class="layoutBlock detailPresentationListItem">
                    <div class="columnDetailLabel detailPresentationListLabel"><span>{{'fs.res.common.researchAreasKdsf' | hisUi}}</span></div>
                    <div class="columnDetailContent detailPresentationListContent wordBreak">
                        <span *ngFor="let researchAreaKdsf of publication.researchAreasKdsf">
                            <a [routerLink]="['/pub/searchresult']"
                                [queryParams]="{configFile: 'fs/res/searchPublicationHeadless.xml', pageTitle: 'fs.res.publication.search.data',
                                tableTitle: 'fs.res.publication.search.found', 'Publication.researchAreasKdsf.id[]': getResearchAreaString(researchAreaKdsf), 'extended': true, showBackButton:true, isNotActiveSearch:true}"
                                hisImage="tag_orange"
                                class="singleLine transparent"
                                title="{{ 'fs.res.common.researchAreasKdsf' | hisUi }}">{{researchAreaKdsf.text}}</a>
                        </span>
                    </div>
                </div>
                <div *ngIf="!isEmpty(publication.researchAreas)" class="layoutBlock detailPresentationListItem">
                    <div class="columnDetailLabel detailPresentationListLabel"><span>{{'value.ResearchAreaValue' | hisUi}}</span></div>
                    <div class="columnDetailContent detailPresentationListContent wordBreak">
                        <span *ngFor="let researchArea of publication.researchAreas">
                            <a [routerLink]="['/pub/searchresult']"
                                [queryParams]="{configFile: 'fs/res/searchPublicationHeadless.xml', pageTitle: 'fs.res.publication.search.data',
                                tableTitle: 'fs.res.publication.search.found', 'Publication.researchAreas.id[]': getResearchAreaString(researchArea), 'extended': true, showBackButton:true, isNotActiveSearch:true}"
                                hisImage="tag_orange"
                                class="singleLine transparent"
                                title="{{ 'fs.res.common.researcharea' | hisUi }}">{{researchArea.text}}</a>
                        </span>
                    </div>
                </div>
				<div *ngIf="!isEmpty(publication.keyWords)" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel"><span>{{'fs.res.publication.Publication.keywords' | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent wordBreak">
						<span *ngFor="let key of publication.keyWords">
							<a [routerLink]="['/pub/searchresult']"
								[queryParams]="{configFile: 'fs/res/searchPublicationHeadless.xml', pageTitle: 'fs.res.publication.search.data',
								tableTitle: 'fs.res.publication.search.found', 'Publication.keyWords.defaulttext': key.defaulttext, 'extended': true, showBackButton:true, isNotActiveSearch:true}"
								hisImage="tag_orange"
								class="singleLine transparent"
								title="{{ 'fs.res.common.keyWord' | hisUi }}">{{key.defaulttext}}</a>
						</span>
					</div>
				</div>
				<div *ngIf="publication.commentary" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel"><span>{{'fs.res.publication.Publication.commentary' | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent">
						<span>{{publication.commentary}}</span>
					</div>
				</div>
				<div *ngIf="publication.visibilityValue" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel"><span>{{'fs.res.publication.Publication.visibilityValue' | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent">
						<span>{{publication.visibilityValue.defaulttext}}</span>
					</div>
				</div>

                <div *ngFor="let dynAttr of dynAttributesList" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel wordBreak"><span>{{dynAttr.labelKey | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent">
						<span>{{dynAttr.value}}</span>
					</div>
				</div>
			</div>
		</div>
</div>
